<style lang="scss" scoped>
.form-item-height {
    height: 22px;
}
.tip-font {
    line-height: 12px;
    font-size: 12px;
    position: relative;
    top: -8px;
    color: #ed3f14;
    font-weight: normal;
}
</style>
<template>
    <div>
        <compWrapper
            :title="
                $t('boss.purchase.basic_information_supplier_products', {
                    defaultValue: '供应商产品基本信息',
                })
            "
            theme="primary"
        >
            <vForm
                :label-width="150"
                :model="formData"
                class="clearfix margin-15 creareform queryform"
                ref="applicateform"
            >
                <vCol span="12">
                    <vFormItem label="ERP SKU" v-if="type != 'add'">
                        <div class="font-weight">
                            <a @click="querysku">{{
                                formData.erpsku || "--"
                            }}</a>
                        </div>
                    </vFormItem>
                    <vFormItem
                        label="ERP SKU"
                        prop="erpsku"
                        :rules="required"
                        v-else
                    >
                        <vInput
                            v-model="formData.erpsku"
                            readonly
                            suffix="search"
                            @on-icon-click="handleSkuErp"
                        ></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.supplier', {
                                defaultValue: '供应商',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{ getSupplier(formData.supplierId) }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.supplier', {
                                defaultValue: '供应商',
                            })
                        "
                        :rules="required"
                        prop="supplierId"
                        v-else-if="type === 'edit'"
                        style="height: 42px"
                    >
                        <vSelect
                            v-model="formData.supplierId"
                            filterable
                            clearable
                        >
                            <vOption
                                v-for="(item, index) in supplierList"
                                :value="item.value"
                                :key="index"
                                >{{ item.label }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.supplier', {
                                defaultValue: '供应商',
                            })
                        "
                        :rules="required"
                        prop="supplierId"
                        v-else
                        style="height: 42px"
                    >
                        <vSelect
                            v-model="formData.supplierId"
                            filterable
                            clearable
                        >
                            <vOption
                                v-for="(item, index) in getNewSupplier"
                                :value="item.value"
                                :key="index"
                                >{{ item.label }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.project', {
                                defaultValue: '项目',
                            })
                        "
                    >
                        <div class="font-weight">
                            {{ getProduct(formData.lineId) }} ({{
                                getProduct(formData.lineId, true)
                            }})
                        </div>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.minimum_sales_unit', {
                                defaultValue: '最小销售单位',
                            })
                        "
                    >
                        <div class="font-weight">
                            {{ getUnit(formData.unit) }}
                        </div>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.factory_product_code', {
                                defaultValue: '工厂产品编码',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{ formData.factoryCode || "--" }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.factory_product_code', {
                                defaultValue: '工厂产品编码',
                            })
                        "
                        v-else
                        style="height: 42px"
                    >
                        <vInput min="0" v-model="formData.factoryCode"></vInput>
                        <!-- <span class="tip-font" style="">如果ERP SKU和工厂产品编码不相同，建议填写</span> -->
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.factory_product_code', {
                                defaultValue: '工厂产品编码分货号',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{ formData.articleNumber || "--" }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.factory_product_code', {
                                defaultValue: '工厂产品编码分货号',
                            })
                        "
                        v-else
                        style="height: 42px"
                    >
                        <vInput v-model="formData.articleNumber"></vInput>
                        <!-- <span class="tip-font" style="">如果ERP SKU和工厂产品编码不相同，建议填写</span> -->
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.production_cycle', {
                                defaultValue: '生产周期',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">{{ formData.cycle }}天</div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.production_cycle', {
                                defaultValue: '生产周期',
                            })
                        "
                        prop="cycle"
                        v-else
                        style="height: 42px"
                        :rules="required"
                    >
                        <Row>
                            <vCol span="22">
                                <vInputNumber
                                    min="0"
                                    v-model="formData.cycle"
                                ></vInputNumber>
                            </vCol>
                            <vCol span="1">
                                <div style="text-align: right">
                                    {{
                                        $t("boss.purchase.day", {
                                            defaultValue: "天",
                                        })
                                    }}
                                </div>
                            </vCol>
                        </Row>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.minimum_order_quantity', {
                                defaultValue: '最小起订量',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{ formData.minOrderQuantity }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.minimum_order_quantity', {
                                defaultValue: '最小起订量',
                            })
                        "
                        prop="minOrderQuantity"
                        :rules="required"
                        v-else
                        style="height: 42px"
                    >
                        <vInputNumber
                            min="1"
                            v-model="formData.minOrderQuantity"
                        ></vInputNumber>
                    </vFormItem>
                </vCol>
                <vCol span="12" v-if="type == 'query'">
                    <vFormItem
                        :label="
                            $t('boss.purchase.packing_quantity', {
                                defaultValue: '装箱入数',
                            })
                        "
                    >
                        <div class="font-weight">
                            {{ formData.cartonPackedQty }}
                        </div>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.main_materials', {
                                defaultValue: '主材',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{ formData.material || "--" }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.main_materials', {
                                defaultValue: '主材',
                            })
                        "
                        v-else
                        style="height: 42px"
                    >
                        <vInput v-model="formData.material"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.additional_function', {
                                defaultValue: '附加功能',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{ formData.features || "--" }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.additional_function', {
                                defaultValue: '附加功能',
                            })
                        "
                        v-else
                        style="height: 42px"
                    >
                        <vInput v-model="formData.features"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.net_weight_produc', {
                                defaultValue: '产品净重（lbs）',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{ formData.netWeight || "--" }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.net_weight_produc', {
                                defaultValue: '产品净重（lbs）',
                            })
                        "
                        v-else
                        style="height: 42px"
                    >
                        <vInputNumber
                            min="0"
                            v-model="formData.netWeight"
                        ></vInputNumber>
                    </vFormItem>
                </vCol>
                <vCol span="12" v-if="type !== 'query'">
                    <vFormItem
                        :label="
                            $t('boss.purchase.gross_weight_product', {
                                defaultValue: '产品毛重（lb）',
                            })
                        "
                        style="height: 42px"
                    >
                        <vInputNumber
                            min="0"
                            placeholder="Weight"
                            :precision="4"
                            v-model="sizeContainer.weight"
                        ></vInputNumber>
                    </vFormItem>
                </vCol>
                <div class="clearfix inline-div" v-if="type === 'query'">
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.individual_packaging_size', {
                                    defaultValue: '单品外包装尺寸（inch）',
                                })
                            "
                            style="height: 42px"
                        >
                            <div class="font-weight">
                                {{ sizeContainer.length }} *
                                {{ sizeContainer.width }} *
                                {{ sizeContainer.height }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.gross_weight_product', {
                                    defaultValue: '产品毛重（lb）',
                                })
                            "
                            style="height: 42px"
                        >
                            <div class="font-weight">
                                {{ sizeContainer.weight }}
                            </div>
                        </vFormItem>
                    </vCol>
                </div>
                <div class="clearfix inline-div" v-else>
                    <vCol span="6">
                        <vFormItem
                            :label="
                                $t('boss.purchase.individual_packaging_size', {
                                    defaultValue: '单品外包装尺寸（inch）',
                                })
                            "
                            style="height: 42px"
                        >
                            <vInputNumber
                                min="0"
                                placeholder="Length"
                                :precision="4"
                                v-model="sizeContainer.length"
                            ></vInputNumber>
                        </vFormItem>
                    </vCol>
                    <vCol span="6">
                        <vFormItem label :labelWidth="20" style="height: 42px">
                            <vInputNumber
                                min="0"
                                placeholder="Width"
                                :precision="4"
                                v-model="sizeContainer.width"
                            ></vInputNumber>
                        </vFormItem>
                    </vCol>
                    <vCol span="6">
                        <vFormItem label :labelWidth="20" style="height: 42px">
                            <vInputNumber
                                min="0"
                                placeholder="Height"
                                :precision="4"
                                v-model="sizeContainer.height"
                            ></vInputNumber>
                        </vFormItem>
                    </vCol>
                </div>
                <div class="clearfix inline-div" v-if="type !== 'query'">
                    <vCol span="6">
                        <vFormItem
                            :label="
                                $t('boss.purchase.single_item_unfolded_size', {
                                    defaultValue: '单品展开尺寸（inch）',
                                })
                            "
                            style="height: 42px"
                        >
                            <vInputNumber
                                min="0"
                                placeholder="Length"
                                :precision="4"
                                v-model="sizeContainer.productSpreadLength"
                            ></vInputNumber>
                        </vFormItem>
                    </vCol>
                    <vCol span="6">
                        <vFormItem label :labelWidth="20" style="height: 42px">
                            <vInputNumber
                                min="0"
                                placeholder="Width"
                                :precision="4"
                                v-model="sizeContainer.productSpreadWidth"
                            ></vInputNumber>
                        </vFormItem>
                    </vCol>
                    <vCol span="6">
                        <vFormItem label :labelWidth="20" style="height: 42px">
                            <vInputNumber
                                min="0"
                                placeholder="Height"
                                :precision="4"
                                v-model="sizeContainer.productSpreadHeight"
                            ></vInputNumber>
                        </vFormItem>
                    </vCol>
                </div>
                <div class="clearfix inline-div" v-else>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.single_item_unfolded_size', {
                                    defaultValue: '单品展开尺寸（inch）',
                                })
                            "
                            v-if="type == 'query'"
                        >
                            <div class="font-weight">
                                {{ sizeContainer.productSpreadLength }} *
                                {{ sizeContainer.productSpreadWidth }} *
                                {{ sizeContainer.productSpreadHeight }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <!-- <vCol span="12">
                        <vFormItem label="单品展开宽（inch）" v-if="type=='query'">
                            <div class="font-weight">{{sizeContainer.productSpreadWidth}}</div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem label="单品展开高（inch）" v-if="type=='query'">
                            <div class="font-weight">{{sizeContainer.productSpreadHeight}}</div>
                        </vFormItem>
                    </vCol>-->
                </div>
                <div class="clearfix inline-div" v-if="type === 'query'">
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.outer_box_size', {
                                    defaultValue: '外箱尺寸（inch）',
                                })
                            "
                            style="height: 42px"
                        >
                            <div class="font-weight">
                                {{ sizeContainer.cartonLength }} *
                                {{ sizeContainer.cartonWidth }} *
                                {{ sizeContainer.cartonHeight }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.outer_box_lb', {
                                    defaultValue: '外箱毛重（lb）',
                                })
                            "
                            style="height: 42px"
                        >
                            <div class="font-weight">
                                {{ sizeContainer.cartonWeight }}
                            </div>
                        </vFormItem>
                    </vCol>
                </div>
                <div class="clearfix inline-div" v-else>
                    <vCol span="6">
                        <vFormItem
                            :label="
                                $t('boss.purchase.outer_box_size', {
                                    defaultValue: '外箱尺寸（inch）',
                                })
                            "
                            style="height: 42px"
                        >
                            <vInputNumber
                                min="0"
                                placeholder="Length"
                                :precision="4"
                                v-model="sizeContainer.cartonLength"
                            ></vInputNumber>
                        </vFormItem>
                    </vCol>
                    <vCol span="6">
                        <vFormItem label :labelWidth="20" style="height: 42px">
                            <vInputNumber
                                min="0"
                                placeholder="Width"
                                :precision="4"
                                v-model="sizeContainer.cartonWidth"
                            ></vInputNumber>
                        </vFormItem>
                    </vCol>
                    <vCol span="6">
                        <vFormItem label :labelWidth="20" style="height: 42px">
                            <vInputNumber
                                min="0"
                                placeholder="Height"
                                :precision="4"
                                v-model="sizeContainer.cartonHeight"
                            ></vInputNumber>
                        </vFormItem>
                    </vCol>
                </div>
                <div class="clearfix inline-div" v-if="type !== 'query'">
                    <vCol span="6">
                        <vFormItem
                            :label="
                                $t('boss.purchase.outer_box_lb', {
                                    defaultValue: '外箱毛重（lb）',
                                })
                            "
                            style="height: 42px"
                        >
                            <vInputNumber
                                min="0"
                                placeholder="Weight"
                                :precision="4"
                                v-model="sizeContainer.cartonWeight"
                            ></vInputNumber>
                        </vFormItem>
                    </vCol>
                    <vCol span="12" offset="6">
                        <vFormItem
                            :label="
                                $t('boss.purchase.packing_quantity', {
                                    defaultValue: '装箱入数',
                                })
                            "
                            style="height: 42px"
                        >
                            <vInputNumber
                                min="1"
                                :precision="0"
                                v-model="formData.cartonPackedQty"
                            ></vInputNumber>
                        </vFormItem>
                    </vCol>
                </div>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.individual_packaging_shape', {
                                defaultValue: '单品包装形状',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{
                                formData.shapeType === 0
                                    ? $t("boss.purchase.cuboid", {
                                          defaultValue: "长方体",
                                      })
                                    : $t("boss.purchase.isoform", {
                                          defaultValue: "异形体",
                                      })
                            }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.individual_packaging_shape', {
                                defaultValue: '单品包装形状',
                            })
                        "
                        prop="shapeType"
                        :rules="required"
                        v-else
                        style="height: 42px"
                    >
                        <vSelect v-model="formData.shapeType">
                            <vOption :value="0">{{
                                $t("boss.purchase.cuboid", {
                                    defaultValue: "长方体",
                                })
                            }}</vOption>
                            <vOption :value="1">{{
                                $t("boss.purchase.isoform", {
                                    defaultValue: "异形体",
                                })
                            }}</vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.single_item_packaging_material', {
                                defaultValue: '单品包装材质',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{
                                formData.materialType === 0
                                    ? $t("boss.purchase.", {
                                          defaultValue: "纸箱",
                                      })
                                    : $t("boss.purchase.other", {
                                          defaultValue: "其他",
                                      })
                            }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.single_item_packaging_material', {
                                defaultValue: '单品包装材质',
                            })
                        "
                        prop="materialType"
                        :rules="required"
                        v-else
                        style="height: 42px"
                    >
                        <vSelect v-model="formData.materialType">
                            <vOption :value="0">{{
                                $t("boss.purchase.carton", {
                                    defaultValue: "纸箱",
                                })
                            }}</vOption>
                            <vOption :value="1">{{
                                $t("boss.purchase.other", {
                                    defaultValue: "其它",
                                })
                            }}</vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.is_it_magnetic', {
                                defaultValue: '是否带磁',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{ getBoolean(formData.isMagnetism) }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.is_it_magnetic', {
                                defaultValue: '是否带磁',
                            })
                        "
                        prop="isMagnetism"
                        :rules="required"
                        v-else
                        style="height: 42px"
                    >
                        <!-- <vSelect v-model="formData.isMagnetism">
                            <vOption :value="0">否</vOption>
                            <vOption :value="1">是</vOption>
                        </vSelect>-->
                        <RadioGroup v-model="formData.isMagnetism">
                            <Radio :label="1">{{
                                $t("boss.purchase.correct", {
                                    defaultValue: "是",
                                })
                            }}</Radio>
                            <Radio :label="0">{{
                                $t("boss.purchase.deny", {
                                    defaultValue: "否",
                                })
                            }}</Radio>
                        </RadioGroup>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.does_it_contain_liquid', {
                                defaultValue: '是否含液体',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{ getBoolean(formData.isLiquid) }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.does_it_contain_liquid', {
                                defaultValue: '是否含液体',
                            })
                        "
                        prop="isLiquid"
                        :rules="required"
                        v-else
                        style="height: 42px"
                    >
                        <!-- <vSelect v-model="formData.isLiquid">
                            <vOption :value="0">否</vOption>
                            <vOption :value="1">是</vOption>
                        </vSelect>-->
                        <RadioGroup v-model="formData.isLiquid">
                            <Radio :label="1">{{
                                $t("boss.purchase.correct", {
                                    defaultValue: "是",
                                })
                            }}</Radio>
                            <Radio :label="0">{{
                                $t("boss.purchase.deny", {
                                    defaultValue: "否",
                                })
                            }}</Radio>
                        </RadioGroup>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.does_it_contain_battery', {
                                defaultValue: '是否含电池',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{ getBoolean(formData.isContainBattery) }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.does_it_contain_battery', {
                                defaultValue: '是否含电池',
                            })
                        "
                        prop="isContainBattery"
                        :rules="required"
                        v-else
                        style="height: 42px"
                    >
                        <!-- <vSelect v-model="formData.isContainBattery">
                            <vOption :value="0">否</vOption>
                            <vOption :value="1">是</vOption>
                        </vSelect>-->
                        <RadioGroup
                            v-model="formData.isContainBattery"
                            @on-change="handleContainBattery"
                        >
                            <Radio :label="1">{{
                                $t("boss.purchase.correct", {
                                    defaultValue: "是",
                                })
                            }}</Radio>
                            <Radio :label="0">{{
                                $t("boss.purchase.deny", {
                                    defaultValue: "否",
                                })
                            }}</Radio>
                        </RadioGroup>
                    </vFormItem>
                </vCol>
                <vCol v-if="isShowBattery" span="12">
                    <vFormItem
                        :label="
                            $t('erp.product.battery_power', {
                                defaultValue: '电池功率',
                            }) + '(WH)'
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{ formData.batteryPower }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('erp.product.battery_power', {
                                defaultValue: '电池功率',
                            }) + '(WH)'
                        "
                        prop="batteryPower"
                        :rules="required"
                        v-else
                        style="height: 42px"
                    >
                        <vInputNumber
                            v-model="formData.batteryPower"
                        ></vInputNumber>
                    </vFormItem>
                </vCol>
                <vCol v-if="isShowBattery" span="12">
                    <vFormItem
                        :label="
                            $t('erp.product.battery_type', {
                                defaultValue: '电池类型',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{
                                handleShowSelect(
                                    formData.batteryType,
                                    getBatteryType
                                )
                            }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('erp.product.battery_type', {
                                defaultValue: '电池类型',
                            })
                        "
                        prop="batteryType"
                        :rules="required"
                        v-else
                        style="height: 42px"
                    >
                        <vSelect v-model="formData.batteryType">
                            <vOption
                                v-for="item in getBatteryType"
                                :key="item.value"
                                :value="item.value"
                                >{{ item.label }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol v-if="isShowBattery" span="12">
                    <vFormItem
                        :label="
                            $t('erp.product.battery_package_type', {
                                defaultValue: '电池包装方式',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{
                                handleShowSelect(
                                    formData.batteryPackageType,
                                    getBatteryPackageType
                                )
                            }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('erp.product.battery_package_type', {
                                defaultValue: '电池包装方式',
                            })
                        "
                        prop="batteryPackageType"
                        :rules="required"
                        v-else
                        style="height: 42px"
                    >
                        <vSelect
                            v-model="formData.batteryPackageType"
                            @on-change="handleBatteryType"
                        >
                            <vOption
                                v-for="item in getBatteryPackageType"
                                :key="item.value"
                                :value="item.value"
                                >{{ item.label }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol v-if="isShowBattery" span="12">
                    <vFormItem
                        :label="
                            $t('erp.product.battery_weight', {
                                defaultValue: '电池重量',
                            }) + '（lb）'
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{ formData.batteryWeight }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('erp.product.battery_weight', {
                                defaultValue: '电池重量',
                            }) + '（lb）'
                        "
                        prop="batteryWeight"
                        :rules="isRequireBatteryWeight ? required : ''"
                        v-else
                        style="height: 42px"
                    >
                        <vInputNumber v-model="formData.batteryWeight" />
                    </vFormItem>
                </vCol>
                <vCol v-if="isShowBattery" span="12">
                    <vFormItem
                        :label="
                            $t('erp.product.battery_label', {
                                defaultValue: '是否已经张贴电池标',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{ getBoolean(formData.batteryLabel) }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('erp.product.battery_label', {
                                defaultValue: '是否已经张贴电池标',
                            })
                        "
                        prop="batteryLabel"
                        :rules="required"
                        v-else
                        style="height: 42px"
                    >
                        <RadioGroup
                            v-model="formData.batteryLabel"
                            @on-change="handleBatteryLabel"
                        >
                            <Radio
                                v-for="item in getIsBatteryLabel"
                                :key="item.trueValue"
                                :label="item.trueValue"
                                >{{ item.label }}</Radio
                            >
                        </RadioGroup>
                    </vFormItem>
                </vCol>
                <vCol v-if="isShowBattery" span="12">
                    <vFormItem
                        :label="
                            $t('erp.product.battery_label_type', {
                                defaultValue: '电池标类型',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{
                                handleShowSelect(
                                    formData.batteryLabelType,
                                    getBatteryLabelType
                                )
                            }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('erp.product.battery_label_type', {
                                defaultValue: '电池标类型',
                            })
                        "
                        prop="batteryLabelType"
                        :rules="isRequireLabelType ? required : ''"
                        v-else
                        style="height: 42px"
                    >
                        <vSelect v-model="formData.batteryLabelType">
                            <vOption
                                v-for="item in getBatteryLabelType"
                                :key="item.value"
                                :value="item.value"
                                >{{ item.label }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.is_it_fragile', {
                                defaultValue: '是否易碎',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{ getBoolean(formData.isFragile) }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.is_it_fragile', {
                                defaultValue: '是否易碎',
                            })
                        "
                        prop="isFragile"
                        :rules="required"
                        v-else
                        style="height: 42px"
                    >
                        <!-- <vSelect v-model="formData.isFragile">
                            <vOption :value="0">否</vOption>
                            <vOption :value="1">是</vOption>
                        </vSelect>-->
                        <RadioGroup v-model="formData.isFragile">
                            <Radio :label="1">{{
                                $t("boss.purchase.correct", {
                                    defaultValue: "是",
                                })
                            }}</Radio>
                            <Radio :label="0">{{
                                $t("boss.purchase.deny", {
                                    defaultValue: "否",
                                })
                            }}</Radio>
                        </RadioGroup>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.outer_box_packaging_material', {
                                defaultValue: '外箱包装材质',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{
                                formData.cartonMaterialType === 0
                                    ? $t("boss.purchase.carton", {
                                          defaultValue: "纸箱",
                                      })
                                    : $t("boss.purchase.other", {
                                          defaultValue: "其他",
                                      })
                            }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.outer_box_packaging_material', {
                                defaultValue: '外箱包装材质',
                            })
                        "
                        prop="cartonMaterialType"
                        :rules="required"
                        v-else
                        style="height: 42px"
                    >
                        <vSelect v-model="formData.cartonMaterialType">
                            <vOption :value="0"
                                >{{
                                    $t("boss.purchase.carton", {
                                        defaultValue: "纸箱",
                                    })
                                }}
                            </vOption>
                            <vOption :value="1">{{
                                $t("boss.purchase.other", {
                                    defaultValue: "其它",
                                })
                            }}</vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.maximum_number_stackable', {
                                defaultValue: '外箱最高可堆叠层数',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{ formData.cartonMaxStacking }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.maximum_number_stackable', {
                                defaultValue: '外箱最高可堆叠层数',
                            })
                        "
                        v-else
                        style="height: 42px"
                    >
                        <vInput v-model="formData.cartonMaxStacking"></vInput>
                        <span class="tip-font"
                            >{{
                                $t("boss.purchase.means_no_requirements", {
                                    defaultValue:
                                        "仓库入库时会堆叠外箱，不填则表示无要求",
                                })
                            }}
                        </span>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.customs_declaration_english', {
                                defaultValue: '报关品名（英文）',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">{{ formData.htsname }}</div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.customs_declaration_english', {
                                defaultValue: '报关品名（英文）',
                            })
                        "
                        v-else
                        style="height: 42px"
                    >
                        <vInput v-model="formData.htsname"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.customs_declaration_chinese', {
                                defaultValue: '报关品名（中文）',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">{{ formData.htsnameCn }}</div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.customs_declaration_chinese', {
                                defaultValue: '报关品名（中文）',
                            })
                        "
                        v-else
                        style="height: 42px"
                    >
                        <vInput v-model="formData.htsnameCn"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.port_delivery', {
                                defaultValue: '交货港',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{ formData.deliveryPort }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.port_delivery', {
                                defaultValue: '交货港',
                            })
                        "
                        v-else
                        style="height: 42px"
                        prop="deliveryPort"
                        :rules="required"
                    >
                        <Select
                            v-model="formData.deliveryPort"
                            :clearable="true"
                            :filterable="true"
                        >
                            <Option
                                v-for="item in portList"
                                :key="item.value"
                                :value="item.value"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </vFormItem>
                </vCol>

                <vCol span="12">
                    <vFormItem label="HS CODE" v-if="type == 'query'">
                        <div class="font-weight">{{ formData.hsCode }}</div>
                    </vFormItem>
                    <vFormItem label="HS CODE" v-else style="height: 42px">
                        <vInput v-model="formData.hsCode"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.quantity_high_cabinet', {
                                defaultValue: '高柜整柜装柜数量',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{ formData.containerQuantity }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.quantity_high_cabinet', {
                                defaultValue: '高柜整柜装柜数量',
                            })
                        "
                        v-else
                        style="height: 42px"
                    >
                        <vInputNumber
                            min="0"
                            v-model="formData.containerQuantity"
                        ></vInputNumber>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.invoice_product_name', {
                                defaultValue: '开票品名',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{ formData.invoiceName }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.invoice_product_name', {
                                defaultValue: '开票品名',
                            })
                        "
                        v-else
                        style="height: 42px"
                    >
                        <vInput v-model="formData.invoiceName"></vInput>
                        <span class="tip-font"
                            >{{
                                $t("boss.purchase.this_field_is_required", {
                                    defaultValue:
                                        "如果有人民币采购单价，该栏位必填",
                                })
                            }}
                        </span>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.invoice_quantity_unit', {
                                defaultValue: '开票数量单位',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{ formData.invoiceQuantityUnit }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.invoice_quantity_unit', {
                                defaultValue: '开票数量单位',
                            })
                        "
                        v-else
                        style="height: 42px"
                    >
                        <vInput v-model="formData.invoiceQuantityUnit"></vInput>
                        <span class="tip-font"
                            >{{
                                $t("boss.purchase.this_field_is_required", {
                                    defaultValue:
                                        "如果有人民币采购单价，该栏位必填",
                                })
                            }}
                        </span>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.product_description', {
                                defaultValue: '产品描述',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{ formData.productDescription }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.product_description', {
                                defaultValue: '产品描述',
                            })
                        "
                        v-else
                        style="height: 42px"
                    >
                        <vInput v-model="formData.productDescription"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.bidder', {
                                defaultValue: '报价人',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">{{ formData.inquirer }}</div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.bidder', {
                                defaultValue: '报价人',
                            })
                        "
                        v-else
                        style="height: 42px"
                    >
                        <vInput v-model="formData.inquirer"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.quotation_deadline', {
                                defaultValue: '报价截止日期',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{ formData.quotationDeadline || "--" }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.quotation_deadline', {
                                defaultValue: '报价截止日期',
                            })
                        "
                        style="height: 42px"
                        v-else
                    >
                        <vDatepicker
                            v-model="formData.quotationDeadline"
                            format="yyyy-mm-dd"
                        ></vDatepicker>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.is_procurement_contract', {
                                defaultValue: '是否签订预采合同',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{
                                (formData.prePurchaseType == 1
                                    ? $t("boss.purchase.correct", {
                                          defaultValue: "是",
                                      })
                                    : $t("boss.purchase.deny", {
                                          defaultValue: "否",
                                      })) || "--"
                            }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.is_procurement_contract', {
                                defaultValue: '是否签订预采合同',
                            })
                        "
                        v-else
                    >
                        <RadioGroup v-model="formData.prePurchaseType">
                            <Radio :label="1">{{
                                $t("boss.purchase.correct", {
                                    defaultValue: "是",
                                })
                            }}</Radio>
                            <Radio :label="0">{{
                                $t("boss.purchase.deny", {
                                    defaultValue: "否",
                                })
                            }}</Radio>
                        </RadioGroup>
                    </vFormItem>
                </vCol>
                <vCol span="12" v-if="formData.prePurchaseType == 1">
                    <vFormItem
                        :label="
                            $t(
                                'boss.purchase.pre_procurement_production_cycle',
                                {
                                    defaultValue: '预采生产周期',
                                }
                            )
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{ formData.prePurchaseCycle || "--" }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t(
                                'boss.purchase.pre_procurement_production_cycle',
                                {
                                    defaultValue: '预采生产周期',
                                }
                            )
                        "
                        style="height: 42px"
                        prop="prePurchaseCycle"
                        :rules="formData.prePurchaseType == 1 ? required : ''"
                        v-else
                    >
                        <vInputNumber
                            v-model="formData.prePurchaseCycle"
                            :min="0"
                        ></vInputNumber>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.notes', {
                                defaultValue: '备注',
                            })
                        "
                    >
                        <div v-if="type == 'query'" class="font-weight">
                            {{ formData.remark || "--" }}
                        </div>
                        <vTextarea v-else v-model="formData.remark"></vTextarea>
                    </vFormItem>
                </vCol>
            </vForm>
            <!-- <template v-if="type!='query'" slot="footer">
                <vButton class="margin-right-20" theme="primary" @click="submit">保存</vButton>
                <vButton class="margin-right-20" @click="cancel">返回</vButton>
            </template> -->
        </compWrapper>
        <!-- 采购单价 -->
        <compWrapper
            :title="
                $t('boss.purchase.purchase_unit_price', {
                    defaultValue: '采购单价',
                })
            "
            theme="info"
        >
            <vForm
                :label-width="100"
                class="clearfix margin-15"
                ref="detailform"
            >
                <vCol span="12">
                    <vFormItem
                        class="form-item-height"
                        v-if="type === 'query'"
                        :label="
                            $t('boss.purchase.US_dollar', {
                                defaultValue: '美元(USD)',
                            })
                        "
                    >
                        <div class="font-weight">
                            {{ getPrice(formData.usdPrice) }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="
                            $t('boss.purchase.US_dollar', {
                                defaultValue: '美元(USD)',
                            })
                        "
                    >
                        <vInputNumber
                            min="0"
                            v-model="formData.usdPrice"
                        ></vInputNumber>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        class="form-item-height"
                        v-if="type === 'query'"
                        :label="
                            $t('boss.purchase.chinese_yuan', {
                                defaultValue: '人民币(CNY)',
                            })
                        "
                    >
                        <div class="font-weight">
                            {{ getPrice(formData.cnyPrice) }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="
                            $t('boss.purchase.chinese_yuan', {
                                defaultValue: '人民币(CNY)',
                            })
                        "
                    >
                        <vInputNumber
                            min="0"
                            v-model="formData.cnyPrice"
                        ></vInputNumber>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        class="form-item-height"
                        v-if="type === 'query'"
                        :label="
                            $t('boss.purchase.euro', {
                                defaultValue: '欧元(EUR)',
                            })
                        "
                    >
                        <div class="font-weight">
                            {{ getPrice(formData.eurPrice) }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="
                            $t('boss.purchase.euro', {
                                defaultValue: '欧元(EUR)',
                            })
                        "
                    >
                        <vInputNumber
                            min="0"
                            v-model="formData.eurPrice"
                        ></vInputNumber>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        class="form-item-height"
                        v-if="type === 'query'"
                        :label="
                            $t('boss.purchase.japanese_yen', {
                                defaultValue: '日元(JPY)',
                            })
                        "
                    >
                        <div class="font-weight">
                            {{ getPrice(formData.jpyPrice) }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="
                            $t('boss.purchase.japanese_yen', {
                                defaultValue: '日元(JPY)',
                            })
                        "
                    >
                        <vInputNumber
                            min="0"
                            v-model="formData.jpyPrice"
                        ></vInputNumber>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        class="form-item-height"
                        v-if="type === 'query'"
                        :label="
                            $t('boss.purchase.canadian_dollar', {
                                defaultValue: '加元(CAD)',
                            })
                        "
                    >
                        <div class="font-weight">
                            {{ getPrice(formData.cadPrice) }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="
                            $t('boss.purchase.canadian_dollar', {
                                defaultValue: '加元(CAD)',
                            })
                        "
                    >
                        <vInputNumber
                            min="0"
                            v-model="formData.cadPrice"
                        ></vInputNumber>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        class="form-item-height"
                        v-if="type === 'query'"
                        :label="
                            $t('boss.purchase.pound_sterling', {
                                defaultValue: '英镑(GBP)',
                            })
                        "
                    >
                        <div class="font-weight">
                            {{ getPrice(formData.gbpPrice) }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="
                            $t('boss.purchase.pound_sterling', {
                                defaultValue: '英镑(GBP)',
                            })
                        "
                    >
                        <vInputNumber
                            min="0"
                            v-model="formData.gbpPrice"
                        ></vInputNumber>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        class="form-item-height"
                        v-if="type === 'query'"
                        :label="
                            $t('boss.purchase.mexican_dollar', {
                                defaultValue: '墨西哥元(MXN)',
                            })
                        "
                    >
                        <div class="font-weight">
                            {{ getPrice(formData.mxnPrice) }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="
                            $t('boss.purchase.mexican_dollar', {
                                defaultValue: '墨西哥元(MXN)',
                            })
                        "
                    >
                        <vInputNumber
                            min="0"
                            v-model="formData.mxnPrice"
                        ></vInputNumber>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        class="form-item-height"
                        v-if="type === 'query'"
                        :label="
                            $t('boss.purchase.australian_dollar', {
                                defaultValue: '澳元(AUD)',
                            })
                        "
                    >
                        <div class="font-weight">
                            {{ getPrice(formData.audPrice) }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        v-else
                        :label="
                            $t('boss.purchase.australian_dollar', {
                                defaultValue: '澳元(AUD)',
                            })
                        "
                    >
                        <vInputNumber
                            min="0"
                            v-model="formData.audPrice"
                        ></vInputNumber>
                    </vFormItem>
                </vCol>
            </vForm>
        </compWrapper>

        <!-- 图片上传 -->
        <compWrapper
            :title="
                $t('boss.purchase.image_upload', {
                    defaultValue: '图片上传',
                })
            "
            theme="error"
        >
            <compImage
                :alltype="type"
                :imageformdata="imagedata"
                ref="refcompimage"
            ></compImage>

            <div
                class="text-right margin-top-20 padding-right-20"
                v-show="type != 'query'"
            >
                <vButton theme="primary" @click="submit"
                    >{{ $t("boss.purchase.save", { defaultValue: "保存" }) }}
                </vButton>
                <vButton class="margin-left-10" @click="cancel">{{
                    $t("boss.purchase.return", { defaultValue: "返回" })
                }}</vButton>
            </div>
        </compWrapper>

        <!-- 操作历史 -->
        <compWrapper
            :title="
                $t('boss.purchase.operations_history', {
                    defaultValue: '操作历史',
                })
            "
            theme="gray"
            v-if="type == 'query'"
        >
            <compLog :data="logList" :columns="logcolumns"></compLog>
        </compWrapper>
        <vLoading size="large" transfer :loading="loading"></vLoading>
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-close="modalProps.show = false"
            @on-confirm="modalProps.show = false"
        >
            <component
                v-if="modalProps.component"
                :is="modalProps.component"
                v-bind="modalProps.props"
                @on-close="modalProps.show = false"
                v-on="modalProps.on"
            />
        </compModal>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import {
    HttpGetSupplierProductOne,
    HttpSaveSupplierProductOne,
    HttpGetSystemPortList,
    HttpGetAllSupplier,
} from "@/service/purchase/purchase";
import { HttpGetProductsOne } from "@/service/products/allproducts";
import { HttpGetErpsku } from "@/service/aftersales/aftersales";

// import { HttpGetErpsku} from "@/service/aftersales/aftersales";
import { HttpSysOpLog } from "@/service/boss/allot";
import compErpsku from "./erpsku";
import compImage from "./compimage";
// 数据
import dataMixin from "@/views/datamixin.js";

// import compCheck from './compcheck'
export default {
    props: ["activeid", "querytype", "comorderno"],
    mixins: [dataMixin],
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        // compFormQuery: () => import("@components/templates/formquery"),
        // compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("@components/templates/log"),
        compModal: () => import("@components/templates/modal"),
        // compCheck,
        compErpsku,
        compImage,
    },
    data() {
        return {
            type: this.$route.params.type,
            id: this.$route.query.id,
            productItem: {},
            sizeContainer: {},
            formData: {
                orgId: global.SYSID,
                lineId: "",
                productId: "",
                shapeType: 0,
                materialType: 0,
                isMagnetism: 0,
                isLiquid: 0,
                isContainBattery: 0,
                isFragile: 0,
                cartonMaterialType: 0,
                cartonPackedQty: 1,
                minOrderQuantity: 1,
                prePurchaseCycle: null,
            },
            erpItem: {},
            logList: [],
            loading: false,
            selectloading: false,
            required: [
                {
                    required: true,
                    message: this.$t("boss.purchase.fill_in", {
                        defaultValue: "该信息不能为空,请填写",
                    }),
                },
            ],
            productList: [],
            modalProps: {
                show: false,
                formdata: null,
            },
            imagedata: {},
            portList: [],
            supplierList: [],
            isShowBattery: false,
            isRequireBatteryWeight: false,
            isRequireLabelType: false,
        };
    },
    created() {
        this.getSupplierList();
        this.getPortList();
        this.update();
    },
    watch: {
        comorderno() {
            this.update();
        },
        formData: {
            deep: true,
            immediate: true,
            handler(val) {
                // this.formData.lineId =
            },
        },
    },
    computed: {
        ...mapState("boss", ["products"]),
        ...mapGetters("diction", [
            "getNewProductList",
            "getAllCurrency",
            "getAllSupplier",
        ]),
        getNewSupplier() {
            // return this.getAllSupplier.filter((item) => {
            return this.supplierList.filter((item) => {
                return item.attach.status === "NORMAL";
            });
        },
        logcolumns() {
            return [
                {
                    title: this.$t("boss.purchase.operator", {
                        defaultValue: "操作人",
                    }),
                    width: 80,
                    render: (h, { row }) => {
                        return <div>{row.opUserName}</div>;
                    },
                },
                {
                    title: this.$t("boss.purchase.operation_remarks", {
                        defaultValue: "操作备注",
                    }),
                    render: (h, { row }) => {
                        return <div>{row.opRemark}</div>;
                    },
                },
                {
                    title: this.$t("boss.purchase.operating_time", {
                        defaultValue: "操作时间",
                    }),
                    width: 130,
                    render: (h, { row }) => {
                        return <div>{row.opAt}</div>;
                    },
                },
            ];
        },
        getPaymentType() {
            return [
                {
                    label: this.$t("boss.purchase.nil", { defaultValue: "无" }),
                    value: "undefined",
                },
                {
                    label: this.$t("boss.purchase.self_procurement", {
                        defaultValue: "自采",
                    }),
                    value: "payment",
                },
                {
                    label: this.$t("boss.purchase.agency_operations", {
                        defaultValue: "代运营",
                    }),
                    value: "unpayment",
                },
                {
                    label: this.$t(
                        "boss.purchase.financial_procurement_agency",
                        { defaultValue: "金融代采" }
                    ),
                    value: "fk",
                },
            ];
        },
    },
    methods: {
        async getSupplierList() {
            await HttpGetAllSupplier().then(
                (res) => {
                    this.supplierList = res.data.map((item) => {
                        return {
                            value: item.id,
                            label: `${item.name}`,
                            attach: {
                                ...item,
                            },
                        };
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        handleContainBattery(val) {
            this.isShowBattery = val == 1;
        },
        handleBatteryType(val) {
            this.isRequireBatteryWeight = val == 0;
        },
        handleBatteryLabel(val) {
            this.isRequireLabelType = val == 1;
        },
        handleShowSelect(val, options) {
            let item = options.filter((item) => {
                return item.value == val;
            })[0];
            if (!item || !item.label) return "--";
            return item.label;
        },
        async getPortList() {
            await HttpGetSystemPortList({
                page: 1,
                rows: 1000,
            }).then(
                (res) => {
                    // console.log('res', res);
                    this.portList = res.data.content.map((item) => {
                        return {
                            value: item.title,
                            label: item.title,
                            attach: {
                                ...item,
                            },
                        };
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        querysku() {
            const url = this.$router.resolve({
                name: "allproductsUpdate",
                params: { type: "query" },
                query: { id: this.formData.productId },
            });
            window.open(url.href, "_blank");
        },
        getPrice(value) {
            let result = value;
            if (!value && value != 0) {
                result = "--";
            }
            return result;
        },
        getUnit(value) {
            let salesList = [
                { value: "Bag", label: "Bag-袋、包" },
                { value: "Bar", label: "Bar-条" },
                { value: "Bottle", label: "Bottle-瓶" },
                { value: "Box", label: "Box-盒" },
                { value: "Bundle", label: "Bundle-捆" },
                { value: "Carton", label: "Carton-箱" },
                { value: "Dozen", label: "Dozen-打" },
                { value: "Ea", label: "Ea-个" },
                { value: "Pair", label: "Pair-副" },
                { value: "Pcs", label: "Pcs-件" },
                { value: "Piece", label: "Piece-只" },
                { value: "Set", label: "Set-台、套" },
                { value: "Unit", label: "Unit-辆" },
            ];
            let result = salesList.filter((item) => {
                return item.value === value;
            })[0];
            return result ? result.label : "--";
        },
        //查询ERPSKU
        handleSkuErp() {
            this.modalProps = {
                show: true,
                title: "SKU",
                component: "compErpsku",
                showFooter: false,
                width: 1000,
                props: {
                    initFormData: {
                        "search[EQ_lineId]": "",
                    },
                },
                on: {
                    "on-data": (row) => {
                        // console.log(row)
                        const {
                            id: productId = "",
                            erpSku = "",
                            length = "",
                            width = "",
                            height = "",
                            weight = "",
                            cost: productCost = "",
                            packingSize = "",
                            chargeSize = "",
                            unit = "",
                        } = row;
                        this.erpItem = {
                            qty: this.formData.qty,
                            productId,
                            erpSku,
                            length,
                            width,
                            height,
                            weight,
                            productCost,
                            packingSize,
                            chargeSize,
                        };
                        this.modalProps.show = false;
                        // this.changeErpSku(erpSku)
                        this.formData.productId = productId;
                        this.formData.erpsku = erpSku;
                        this.formData.lineId = row.lineId;
                        this.formData.unit = row.unit;
                        this.getProduct(row.lineId);
                        this.getUnit(row.unit);
                    },
                },
            };
        },
        getBoolean(value) {
            return value === 1
                ? this.$t("boss.purchase.correct", { defaultValue: "是" })
                : this.$t("boss.purchase.deny", { defaultValue: "否" });
        },
        getSupplier(sulierid) {
            let itemarr =
                this.supplierList.filter((item) => {
                    return item.value == sulierid;
                })[0] || {};
            if (itemarr && itemarr.attach) {
                return `${itemarr.label}(${itemarr.attach.code})` || "--";
            } else {
                return "--";
            }
        },
        getProduct(lineId, isReturnPayment = false) {
            // console.log(this.getNewProductList);
            let name =
                this.getNewProductList.filter((item) => {
                    return item.value === lineId;
                })[0] || {};
            if (isReturnPayment) {
                if (name && name.attach) {
                    let payment = this.getPaymentType.filter((item) => {
                        return item.value == name.attach.paymentType;
                    })[0];
                    return payment ? payment.label : "--";
                }
                return "--";
            } else {
                this.formData.productName = name.label;
                return (name = name ? name.label : "--");
            }
        },
        update() {
            if (this.querytype) {
                this.id = this.activeid;
                this.type = this.querytype;
            } else {
                this.id = this.$route.query.id;
                this.type = this.type;
            }
            if (this.type == "add") return;
            this.loading = true;
            // 日志
            if (this.type == "query") {
                HttpSysOpLog({
                    "search[EQ_opDataId]": this.id,
                    "search[EQ_opModel]": "supplier_product",
                }).then(
                    (res) => {
                        // console.log('历史记录请求', res)
                        this.logList = res.data.content;
                        this.loading = false;
                    },
                    (err) => {
                        this.errorMessage(err.message);
                        this.loading = false;
                    }
                );
            }
            // 详情
            if (this.type != "add") {
                // console.log(this.type)
                // HttpGetOrderOne({
                HttpGetSupplierProductOne({
                    id: this.id,
                }).then(
                    (res) => {
                        this.formData = {
                            ...this.formData,
                            ...res.data,
                        };
                        if (res.data.isContainBattery) {
                            this.isShowBattery = true;
                        }
                        if (res.data.batteryPackageType == 0) {
                            this.isRequireBatteryWeight = true;
                        }
                        if (res.data.batteryLabel) {
                            this.isRequireLabelType = true;
                        }
                        this.$set(this.$data, "imagedata", res.data || {});

                        this.formData.usdPrice =
                            this.formData.usdPrice === null
                                ? undefined
                                : this.formData.usdPrice;
                        this.formData.cnyPrice =
                            this.formData.cnyPrice === null
                                ? undefined
                                : this.formData.cnyPrice;
                        this.formData.eurPrice =
                            this.formData.eurPrice === null
                                ? undefined
                                : this.formData.eurPrice;
                        this.formData.jpyPrice =
                            this.formData.jpyPrice === null
                                ? undefined
                                : this.formData.jpyPrice;
                        this.formData.cadPrice =
                            this.formData.cadPrice === null
                                ? undefined
                                : this.formData.cadPrice;
                        this.formData.gbpPrice =
                            this.formData.gbpPrice === null
                                ? undefined
                                : this.formData.gbpPrice;
                        this.formData.mxnPrice =
                            this.formData.mxnPrice === null
                                ? undefined
                                : this.formData.mxnPrice;
                        this.formData.audPrice =
                            this.formData.audPrice === null
                                ? undefined
                                : this.formData.audPrice;

                        this.sizeContainer = {
                            length: res.data.length
                                ? this.handleUnit(
                                      res.data.length,
                                      "cm",
                                      "inch",
                                      2
                                  )
                                : undefined,
                            width: res.data.width
                                ? this.handleUnit(
                                      res.data.width,
                                      "cm",
                                      "inch",
                                      2
                                  )
                                : undefined,
                            height: res.data.height
                                ? this.handleUnit(
                                      res.data.height,
                                      "cm",
                                      "inch",
                                      2
                                  )
                                : undefined,
                            weight: res.data.weight
                                ? this.handleUnit(res.data.weight, "g", "lb", 2)
                                : undefined,
                            cartonLength: res.data.cartonLength
                                ? this.handleUnit(
                                      res.data.cartonLength,
                                      "cm",
                                      "inch",
                                      2
                                  )
                                : undefined,
                            cartonWidth: res.data.cartonWidth
                                ? this.handleUnit(
                                      res.data.cartonWidth,
                                      "cm",
                                      "inch",
                                      2
                                  )
                                : undefined,
                            cartonHeight: res.data.cartonHeight
                                ? this.handleUnit(
                                      res.data.cartonHeight,
                                      "cm",
                                      "inch",
                                      2
                                  )
                                : undefined,
                            cartonWeight: res.data.cartonWeight
                                ? this.handleUnit(
                                      res.data.cartonWeight,
                                      "g",
                                      "lb",
                                      2
                                  )
                                : undefined,
                            productSpreadLength: res.data.productSpreadLength
                                ? this.handleUnit(
                                      res.data.productSpreadLength,
                                      "cm",
                                      "inch",
                                      2
                                  )
                                : undefined,
                            productSpreadWidth: res.data.productSpreadWidth
                                ? this.handleUnit(
                                      res.data.productSpreadWidth,
                                      "cm",
                                      "inch",
                                      2
                                  )
                                : undefined,
                            productSpreadHeight: res.data.productSpreadHeight
                                ? this.handleUnit(
                                      res.data.productSpreadHeight,
                                      "cm",
                                      "inch",
                                      2
                                  )
                                : undefined,
                        };

                        // console.log('转换前', this.formData)
                        // console.log('转换后', this.sizeContainer)

                        HttpGetProductsOne({
                            id: this.formData.productId,
                        }).then(
                            (res) => {
                                this.formData.unit = res.data.unit;
                                this.loading = false;
                            },
                            (err) => {
                                this.$VMessage.error({
                                    content: err.message,
                                    duration: 30,
                                    closable: true,
                                });
                                this.loading = false;
                            }
                        );

                        // this.loading = false;
                    },
                    (err) => {
                        this.errorMessage(err.message);
                        this.loading = false;
                    }
                );
            }
        },
        async submit(typra) {
            const valid = await this.$refs.applicateform.validate();
            if (!valid) return;
            // let priceList = []
            // Object.keys(this.formData.currencyPrice).forEach(keyName => {
            //     if (!this.formData.currencyPrice[keyName]) {
            //         return
            //     }
            //     priceList.push({
            //         price: this.formData.currencyPrice[keyName],
            //         currency: keyName
            //     })
            // })
            // if (priceList.length < 1) {
            if (
                (this.formData.cnyPrice === undefined ||
                    this.formData.cnyPrice === null) &&
                (this.formData.usdPrice === undefined ||
                    this.formData.usdPrice === null) &&
                (this.formData.eurPrice === undefined ||
                    this.formData.eurPrice === null) &&
                (this.formData.jpyPrice === undefined ||
                    this.formData.jpyPrice === null) &&
                (this.formData.cadPrice === undefined ||
                    this.formData.cadPrice === null) &&
                (this.formData.gbpPrice === undefined ||
                    this.formData.gbpPrice === null) &&
                (this.formData.mxnPrice === undefined ||
                    this.formData.mxnPrice === null) &&
                (this.formData.audPrice === undefined ||
                    this.formData.audPrice === null)
                // !this.formData.usdPrice &&
                // !this.formData.eurPrice &&
                // !this.formData.jpyPrice &&
                // !this.formData.cadPrice &&
                // !this.formData.gbpPrice &&
                // !this.formData.mxnPrice &&
                // !this.formData.audPrice
            ) {
                return this.$VMessage.error(
                    this.$t("boss.purchase.unit_price_cannot_be", {
                        defaultValue: "采购单价不能全为空",
                    })
                );
            }
            // 规则验证
            if (this.formData.cnyPrice || this.formData.cnyPrice === 0) {
                if (
                    !this.formData.invoiceName ||
                    !this.formData.invoiceQuantityUnit
                ) {
                    return this.$VMessage.error(
                        this.$t("boss.purchase.when_purchasing_in_RMB", {
                            defaultValue:
                                "有人民币采购时，开票品名和开票数量单位必填！",
                        })
                    );
                }
            }
            // 单位转换
            (this.formData.length = this.sizeContainer.length
                ? parseFloat(
                      this.handleUnit(
                          this.sizeContainer.length,
                          "inch",
                          "cm",
                          4
                      )
                  )
                : null),
                (this.formData.width = this.sizeContainer.width
                    ? parseFloat(
                          this.handleUnit(
                              this.sizeContainer.width,
                              "inch",
                              "cm",
                              4
                          )
                      )
                    : null),
                (this.formData.height = this.sizeContainer.height
                    ? parseFloat(
                          this.handleUnit(
                              this.sizeContainer.height,
                              "inch",
                              "cm",
                              4
                          )
                      )
                    : null),
                (this.formData.weight = this.sizeContainer.weight
                    ? parseFloat(
                          this.handleUnit(
                              this.sizeContainer.weight,
                              "lb",
                              "g",
                              4
                          )
                      )
                    : null),
                (this.formData.cartonLength = this.sizeContainer.cartonLength
                    ? parseFloat(
                          this.handleUnit(
                              this.sizeContainer.cartonLength,
                              "inch",
                              "cm",
                              4
                          )
                      )
                    : null),
                (this.formData.cartonWidth = this.sizeContainer.cartonWidth
                    ? parseFloat(
                          this.handleUnit(
                              this.sizeContainer.cartonWidth,
                              "inch",
                              "cm",
                              4
                          )
                      )
                    : null),
                (this.formData.cartonHeight = this.sizeContainer.cartonHeight
                    ? parseFloat(
                          this.handleUnit(
                              this.sizeContainer.cartonHeight,
                              "inch",
                              "cm",
                              4
                          )
                      )
                    : null),
                (this.formData.cartonWeight = this.sizeContainer.cartonWeight
                    ? parseFloat(
                          this.handleUnit(
                              this.sizeContainer.cartonWeight,
                              "lb",
                              "g",
                              4
                          )
                      )
                    : null);
            (this.formData.productSpreadLength = this.sizeContainer
                .productSpreadLength
                ? parseFloat(
                      this.handleUnit(
                          this.sizeContainer.productSpreadLength,
                          "inch",
                          "cm",
                          4
                      )
                  )
                : null),
                (this.formData.productSpreadWidth = this.sizeContainer
                    .productSpreadWidth
                    ? parseFloat(
                          this.handleUnit(
                              this.sizeContainer.productSpreadWidth,
                              "inch",
                              "cm",
                              4
                          )
                      )
                    : null),
                (this.formData.productSpreadHeight = this.sizeContainer
                    .productSpreadHeight
                    ? parseFloat(
                          this.handleUnit(
                              this.sizeContainer.productSpreadHeight,
                              "inch",
                              "cm",
                              4
                          )
                      )
                    : null);
            // console.log(this.formData.length, this.formData.cartonLength, this.formData.width, this.formData.cartonWidth, this.formData.height, this.formData.cartonHeight)
            // console.log(this.formData.length > this.formData.cartonLength, this.formData.width > this.formData.cartonWidth, this.formData.height > this.formData.cartonHeight)
            // 装箱入数验证
            if (this.formData.cartonPackedQty >= 2) {
                if (
                    this.formData.length > this.formData.cartonLength ||
                    this.formData.width > this.formData.cartonWidth ||
                    this.formData.height > this.formData.cartonHeight
                ) {
                    return this.$VMessage.error(
                        this.$t("boss.purchase.smaller_than_the_individual", {
                            defaultValue: "外箱尺寸小于单品尺寸",
                        })
                    );
                }
                if (this.formData.weight > this.formData.cartonWeight) {
                    return this.$VMessage.error(
                        this.$t("boss.purchase.smaller_than_the_weight", {
                            defaultValue: "外箱尺寸小于单品重量",
                        })
                    );
                }
            }
            // let {currencyPrice, ...requestData } = {
            //     ...this.formData,
            //     priceList: priceList
            // }

            let refimage = this.$refs.refcompimage;
            this.formData.pictures = refimage ? refimage.formList : null;
            let requestData = this.formData;
            this.loading = true;
            HttpSaveSupplierProductOne(requestData).then(
                (res) => {
                    this.loading = false;
                    this.$Message.success(res.message);
                    this.cancel();
                },
                (error) => {
                    this.loading = false;
                    this.$Message.error(error.message);
                }
            );
        },

        cancel() {
            this.$router.push({
                name: "supplierProduct",
            });
        },
    },
};
</script>
